

<!-- Begin: Admin Form -->
<div class="mw1500 center-block">
  <div class="admin-form">

      <div class="panel heading-border">
          <div class="panel-body bg-light">

                  <div class="section-divider mb40" id="spy1">
                      <span>Order Detail  </span>
                  </div>
                  <!-- .section-divider -->

                  <!-- Basic Inputs -->
                  <div class="row" *ngIf="orders">
                      <div class="col-md-4">



                        <div #mapContainer id="map"> </div>



                        <div *ngIf="orders.signature!=undefined">
                          <img style="width: 100%; height: 150px;" [src]="orders.signature" class="img-thumbnail rounded " />
                         </div>
                        <div *ngIf="orders.imgs!=0">
                          <img *ngFor="let img of orders.imgs" (click)="imagenModal(img)" [src]="img" style="width: 180px; height: 140px;" class="img-thumbnail rounded " />
                        </div>




                      </div>
                      <div class="col-md-8 ">

                        <div class="row">

                             <div class="col-md-12">

                                <div class="alert"  [ngStyle]="{'background-color':  getColorStatus(orders.status)  }" style="text-align: center;" role="alert">
                                  {{  statusOrder(orders.status) }}
                                </div>



                          </div>

                          </div>

                          <div class="row ">
                              <div class="col-md-4">

                                      <h3> Name: <br>  <b> {{ orders.firstnamecontact }} {{ orders.lastnamecontact}}  </b> </h3>


                              </div>

                              <div class="col-md-4">
                                     <h3> Date Delivery: <br> <b> {{ orders.datedelivery |  date:'dd/MM/yyyy' }}  </b> </h3>
                              </div>

                              <div class="col-md-4">
                                <h3> Date Reported: <br> <b> {{ orders.reportedDate |  date:'dd/MM/yyyy,  h:mm a' }}  </b> </h3>
                             </div>

                          </div>
                          <div class="row">
                              <div class="col-md-4">
                                      <h3> Address from: <br> <b> {{ orders.address }}  </b> </h3>

                              </div>

                              <div class="col-md-4">
                                <h3> Address to: <br>  <b> {{ orders.address2 }}  </b> </h3>

                              </div>


                          </div>

                          <div class="row">


                            <div class="col-md-4">
                              <h3> Company: <br>  <b> {{ orders.companyname }}  </b> </h3>

                            </div>

                            <div class="col-md-4">
                              <h3> Email: <br>  <b> {{ orders.email }}  </b> </h3>

                            </div>
                            <div *ngIf="orders.phone != 0" class="col-md-4">
                              <h3> Phone: <br>  <b> {{ orders.phone }}  </b> </h3>

                            </div>
                          </div>

                          <div class="row" *ngIf=" orders.description != undefined">

                            <div class="col-md-12">
                              <h3> Description: <br>  <b> {{ orders.description }}  </b> </h3>
                            </div>

                          </div>

                          <div class="row">

                            <div class="col-md-4">
                              <h3> Distance: <br>  <b> {{ orders.distance }}  </b> </h3>

                            </div>

                            <div class="col-md-4">
                              <h3> Time: <br>  <b> {{ orders.time }}  </b> </h3>

                            </div>

                            <div class="col-md-4">
                              <h3> Total: <br>  <b> {{ orders.total }}  </b> </h3>

                            </div>

                          </div>



                          <div *ngIf="orders.driverId!=undefined" class="row">

                              <div class="col-md-4">

                                <h3> Driver: <br>  <b> {{ orders.driverName }}  {{ orders.driverLast }} </b> </h3>

                              </div>

                          </div>

                          <div class="row">


                          </div>

                      </div>
                  </div>


                  <!-- end .form-body section -->
                  <div class="panel-footer text-center ">
                      <button routerLink="/orders"  class="button btn-primary "> Back </button>
                  </div>
                  <!-- end .form-footer section -->

          </div>
      </div>

  </div>
</div>
